<!-- 关联内容组价 -->
<template>
  <div class="relate_wrap">
    <div class="title">
      <span class="item" v-for="it in relatedColumns" :key="it.prop">{{ it.label }}</span>
    </div>
    <template v-if="data && data.length">
      <div class="content" v-for="item in data" :key="item.businessId">
        <span
          class="item item_title"
          :class="{ canClick: item.commitFlag && item.businessType !== 6 }"
          @click="goDetail(item)"
        >
          {{ handleName(item) }}
        </span>
        <span class="item">{{ handleStatus(item, 'commitFlag') }}</span>
        <span class="item">{{ handleStatus(item, 'commitTime') }}</span>
      </div>
    </template>
    <template v-else><a-empty /></template>
  </div>
  <!-- 检查单详情 -->
  <a-modal
    v-model:visible="chekcParams.visible"
    :width="1059"
    title="检查单详情"
    :bodyStyle="{
      padding: '16px 24px 18px 24px'
    }"
    :footer="null"
  >
    <checklistDetail
      :checklistId="chekcParams.checklistId"
      :visible="chekcParams.visible"
    ></checklistDetail>
  </a-modal>
  <!-- 疗效跟踪 -->
  <effectTrack ref="effectTrackRef" />
  <Gauge ref="gDetail" :params="detailQuery" />
  <ImageList
    :visible="imgObj.imgVisible"
    title="量表"
    :tips="imgObj.tips"
    :fileList="imgObj.fileList"
    @cancel="handleCancel"
  />
  <!-- 问卷结果iframe -->
  <Info ref="infoRef" :url="scaleResultsUrl"></Info>
</template>
<script setup>
import { relatedColumns } from '../hooks/config'
import { defineProps, ref, reactive } from 'vue'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail.vue'
import ImageList from '@/components/ImageList'
import effectTrack from './effectTrack.vue'
import checklistDetail from '@/views/HealthRecord/checklistDetail.vue'
import { getsurveyPictureDetail } from '@/api/workPlace/gauge'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'
defineProps({
  data: {
    type: Array,
    default: () => []
  }
})
const effectTrackRef = ref(false)
const goDetail = function (data) {
  const { commitFlag, businessType } = data
  if (!commitFlag) return false
  switch (businessType) {
    case 3:
      goGaugeDetail(data)
      break
    case 4:
      goCheckDetail(data)
      break
    case 5:
      goEffectDetail(data)
      break
    default:
      break
  }
}
const gDetail = ref(null)
const infoRef = ref(null)
const scaleResultsUrl = ref('')
const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})
// 量表详情
function goGaugeDetail(item) {
  const { extra } = item
  if (extra === '图片量表') {
    imageDetail(item)
  } else {
    rowDetail(item)
  }
}
const imgObj = reactive({
  imgVisible: false,
  fileList: [],
  tips: ''
})
const imageDetail = async item => {
  const { commitTime, result: surveySendId } = item
  const res = await getsurveyPictureDetail({ surveySendId })
  imgObj.imgVisible = true
  imgObj.fileList = res.pictureFileList
  imgObj.tips = `上传时间:${commitTime}`
}
// 关闭弹窗
const handleCancel = () => {
  imgObj.imgVisible = false
  imgObj.fileList = []
  imgObj.tips = ''
}
const rowDetail = item => {
  const { businessId, result, subBusinessType } = item
  const arr = result.split('/')
  const len = arr.length
  let surveySendId = null
  if (subBusinessType !== 1 && subBusinessType) {
    scaleResultsUrl.value = result
    return infoRef.value.showDrawer()
  }
  if (len) {
    surveySendId = arr[len - 1]
  }
  detailQuery.surveyId = businessId
  detailQuery.surveySendId = surveySendId
  gDetail.value.gDetailVisible = true
}
const chekcParams = reactive({
  visible: false,
  checklistId: ''
})
// 检查单详情
function goCheckDetail(item) {
  const { result } = item
  chekcParams.visible = true
  chekcParams.checklistId = result
}
// 查看疗效跟踪详情
const goEffectDetail = function (item) {
  effectTrackRef.value?.initModal(item)
}
const handleName = function (item) {
  const { businessType, extra } = item
  let title = ''
  switch (businessType) {
    case 4:
      title = '检查检验单'
      break
    case 5:
      title = '疗效跟踪'
      break
    case 6:
      title = '复诊提醒'
      break
    default:
      title = extra
      break
  }
  return title
}
const handleStatus = function (item, key) {
  const { businessType, commitFlag } = item
  if (businessType === 6) {
    return '--'
  } else {
    if (key === 'commitFlag') {
      return commitFlag ? '已填写' : '未填写'
    } else {
      return item[key] || '--'
    }
  }
}
</script>
<style scoped lang="scss">
.relate_wrap {
  .title,
  .content {
    padding-bottom: 15px;
    display: flex;
    .item {
      flex: 1;
      &:first-child {
        flex: 2;
      }
      // &:nth-child(2) {
      //   flex: 1;
      // }
      // &:last-child {
      //   flex: 5;
      // }
      &.item_title {
        &.canClick {
          cursor: pointer;
          color: #1890ff;
        }
      }
    }
  }
}
</style>
